import React from 'react';
import classNames from 'classnames';
import styles from './LoginPage.module.scss';
import BackgroundStripes from 'ui/icons/background-stripes.svg';

export interface LoginPageProps {
	className?: string;
	children: React.ReactNode;
}

export const LoginPage: React.FC<LoginPageProps> = ({ className, children }) => {
	return (
		<section className={classNames(styles.LoginPage, className)}>
			<div className={styles.LoginPage_graphicContainer}>
				<BackgroundStripes className={styles.LoginPage_graphic} viewBox="0 0 619 969" preserveAspectRatio="none" width="100%" height="auto" />
			</div>
			{children}
		</section>
	);
};
